import * as React from 'react';
// import { MultipleSelectChip } from './MultipleSelectChip';
import Tags from './MultiSelectAutocomplete';

export function Attributes({ autoFill, filters, updateState }) {
    // console.log(filters)
    const feilds = [
        {
            name: 'Colors',
            key: 'Color',
            required: false
        },
        {
            name: 'Base Fabric',
            key: 'Fabric',
            required: false
        },
        {
            name: 'Hand',
            key: 'Hand',
            required: false
        },
        {
            name: 'Material',
            key: 'Material',
            required: false
        },
        {
            name: 'Artwork',
            key: 'Artwork',
            required: false
        },
        {
            name: 'Designer',
            key: 'Artist',
            required: true
        },
        {
            name: 'Effect',
            key: 'Effect',
            required: false
        },
        {
            name: 'Techniques',
            key: 'Techniques',
            required: false
        },
        {
            name: 'Era',
            key: 'Era',
            required: false
        },
        {
            name: 'Group/Tag',
            key: 'Tag',
            required: false
        }
    ];

    return <div className='attirubutes-filter-container'>
        {feilds.map((feild) => {
            return <div key={feild.key} className='input-container'><Tags filterKey={feild.key} value={filters[feild.key]} options={autoFill?.[feild.key] || []} updateState={updateState} inputName={feild.name} required={feild.required} /></div>;
        })}
    </div>;
    // return <div className='attirubutes-filter-container'>
    //     {feilds.map((feild) => {
    //         return <div key={feild.key} className='input-container'><MultipleSelectChip filterKey={feild.key} value={filters[feild.key]} options={autoFill[feild.key]} updateState={updateState} inputName={feild.name} /></div>;
    //     })}
    // </div>;
}
